import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class DiagnosticToolCypressAttribute extends CypressAttribute {
  static buttons = {
    COPY_LINK: 'DiagnosticToolCypressAttribute:buttons:COPY_LINK',
    LAUNCH: 'DiagnosticToolCypressAttribute:buttons:LAUNCH',
    REFRESH: 'DiagnosticToolCypressAttribute:buttons:REFRESH',
    DOWNLOAD: 'DiagnosticToolCypressAttribute:buttons:DOWNLOAD',
    SHARE: 'DiagnosticToolCypressAttribute:buttons:SHARE',
    START_NEW_DIAGNOSTIC: 'DiagnosticToolCypressAttribute:buttons:START_NEW_DIAGNOSTIC',
    SEND_EMAIL: 'DiagnosticToolCypressAttribute:buttons:SEND_EMAIL',
    TRY_AGAIN: 'DiagnosticToolCypressAttribute:buttons:TRY_AGAIN',
    CONSULT: 'DiagnosticToolCypressAttribute:buttons:CONSULT'
  };
  static inputs = {
    EMAIL: 'DiagnosticToolCypressAttribute:inputs:EMAIL'
  };
  static views = {
    DIAGNOSTIC_MEETING_BOOKED: 'TrustPilotCypressAttribute:views:DIAGNOSTIC_MEETING_BOOKED',
    MEETING_CONFIRMED: 'TrustPilotCypressAttribute:views:MEETING_CONFIRMED',
    LAUNCH_CARDS_DIV: 'DiagnosticToolCypressAttribute:views:LAUNCH_CARDS_DIV',
    RESULTS_PAGE: 'DiagnosticToolCypressAttribute:views:RESULTS_PAGE',
    RESULTS_CONTAINER: 'DiagnosticToolCypressAttribute:views:RESULTS_CONTAINER'
  };
}
